import { styled } from "@mui/material";

export const Wrapper = styled("div")(() => ({
  padding: "24px 24px 0 24px",
}));

export const Header = styled("header")(() => ({
  marginBottom: "22px",
}));

export const Section = styled("section")(() => ({}));
